// The one timezone the app shows times in: charts, tables, replay clocks and
// notices, whatever exchange an instrument trades on. Stored and transmitted
// times stay epoch seconds UTC, and calculations that depend on an exchange's
// own calendar (a strategy's trading day, FX fixings) keep using the venue's zone.
export const DISPLAY_TIME_ZONE = "Asia/Kolkata"
